var _style, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardFail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 109 111",
    width: 109,
    height: 111,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Frame 728-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: none;stroke: #191919;stroke-linecap: round;stroke-linejoin: round;stroke-width: 4 } \n\t\t.s1 { fill: none;stroke: #e60121;stroke-linecap: round;stroke-linejoin: round;stroke-width: 4 } \n\t\t.s2 { fill: #e60121;stroke: #ffffff;stroke-linecap: round;stroke-linejoin: round;stroke-width: 4 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m98.5 28v56c0 1.9-1.6 3.5-3.5 3.5h-84c-1.9 0-3.5-1.6-3.5-3.5v-56c0-1.9 1.6-3.5 3.5-3.5h84c1.9 0 3.5 1.6 3.5 3.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m42.5 73.5h14"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m21.5 73.5h7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m7.5 42.4h91"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m103.5 101.3c1.5 1.6 1.4 4.3-0.3 5.8c-1.7 1.5-4.3 1.4-5.8-0.3l-87.3-96.1c-1.6-1.6-1.4-4.3 0.3-5.8c1.6-1.5 4.3-1.4 5.8 0.3z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardFail);
export default __webpack_public_path__ + "static/media/card_fail.1ff16004fd854fcec5bd2d6433b3ebe4.svg";
export { ForwardRef as ReactComponent };